<template>
  <el-row :gutter="20" class="user-management-row">
    <!-- 左侧组织架构树 -->
    <el-col :xs="24" :sm="8" :md="6" style="min-width: 320px">
      <el-card class="tree-card">
        <template #header>
          <div class="clearfix">
            <span>锡林郭勒盟</span>
            <div style="float: right">
              <el-button
                v-if="userInfo.user_type === 1"
                size="small"
                @click="handleAddDepartment"
                >添加旗县</el-button
              >
            </div>
          </div>
        </template>
        <el-tree
          ref="tree"
          :data="orgTree"
          :props="treeProps"
          node-key="id"
          highlight-current
          @node-click="handleNodeClick"
        >
          <template #default="{ node, data }">
            <span class="custom-tree-node">
              <span>{{ node.label }}</span>
              <span style="margin-right: 10px">
                <el-button
                  type="primary"
                  link
                  @click.stop="handleEditDepartment(node, data)"
                  v-if="userInfo.user_type === 1"
                >
                  编辑
                </el-button>
                <el-button
                  type="danger"
                  link
                  @click.stop="handleDeleteDepartment(node, data)"
                  v-if="userInfo.user_type === 1"
                >
                  删除
                </el-button>
              </span>
            </span>
          </template>
        </el-tree>
      </el-card>
    </el-col>

    <!-- 右侧成员表格 -->
    <el-col :xs="24" :sm="16" :md="18" style="min-width: 500px">
      <el-card>
        <div class="table-header">
          <div class="table-actions">
            <el-button type="primary" @click="handleAddUser"
              >添加成员</el-button
            >
            <el-button
              type="danger"
              @click="handleBatchDelete"
              :disabled="!selectedUsers.length"
            >
              删除成员
            </el-button>
          </div>
          <div class="table-filter">
            <el-input
              v-model="filter.keyword"
              placeholder="请输入姓名/手机号"
              style="width: 200px"
              clearable
              @clear="handleFilter"
              @keyup.enter="handleFilter"
            >
              <template #append>
                <el-button icon="el-icon-search" @click="handleFilter" />
              </template>
            </el-input>
          </div>
        </div>

        <el-table
          :data="userList"
          border
          style="width: 100%"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column
            prop="user_name"
            label="姓名"
            min-width="120"
            align="center"
          />

          <!-- <el-table-column
            prop="department.name"
            label="旗县"
            min-width="150"
             align="center"
          /> -->
          <el-table-column
            prop="phone"
            label="手机"
            min-width="150"
            align="center"
          />
          <el-table-column
            prop="email"
            label="邮箱"
            min-width="200"
            align="center"
          />
          <el-table-column
            prop="status"
            label="用户状态"
            min-width="120"
            align="center"
          >
            <template #default="scope">
              <el-tag
                :type="
                  scope.row.status === 1
                    ? 'success'
                    : scope.row.status === 2
                    ? 'info'
                    : 'danger'
                "
                disable-transitions
              >
                {{
                  scope.row.status === 1
                    ? "激活"
                    : scope.row.status === 2
                    ? "未激活"
                    : "锁定"
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180"
            fixed="right"
            align="center"
          >
            <template #default="scope">
              <el-button size="small" @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                v-if="scope.row.status === 2"
                size="small"
                @click="handleSendSMS(scope.row)"
                >通知使用</el-button
              >
              <el-button
                v-if="scope.row.status === 1"
                size="small"
                @click="handleSendSMS(scope.row)"
                >锁定用户</el-button
              >
              <!-- <el-button
                size="small"
                type="danger"
                @click="handleDelete(scope.row)"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination">
          <el-pagination
            v-model:current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            :total="pagination.total"
            layout="total, prev, pager, next"
            @current-change="handlePageChange"
          />
        </div>
      </el-card>
    </el-col>
  </el-row>

  <!-- 添加/编辑用户对话框 -->
  <user-dialog
    :value="dialogVisible"
    @input="(val) => (dialogVisible = val)"
    :user-data="currentUser"
    @refresh="fetchUserList"
    @createUser="handleCreateUser"
    @updateUser="handleUpdateUser"
  >
    <template #footer>
      <span class="dialog-footer"> </span>
    </template>
  </user-dialog>
  <!-- </div> -->
</template>

<script>
import {
  getUserList,
  deleteUser,
  createUser,
  updateUser,
  sendInitPwdBySMS,
} from "@/api/user-management/user";
import {
  getOrgTree,
  createDepartment,
  updateDepartment,
  deleteDepartment,
} from "@/api/user-management/department";
import UserDialog from "@/components/UserDialog";

export default {
  name: "UserManagement",
  components: {
    UserDialog,
  },
  data() {
    return {
      orgTree: [], // 组织架构树数据
      treeProps: {
        label: "name",
        children: "children",
      },
      currentNode: null, // 当前选中的组织节点
      userList: [], // 用户列表数据
      selectedUsers: [], // 表格中选中的用户
      loading: false,
      filter: {
        keyword: "",
        deptId: null,
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      dialogVisible: false,
      currentUser: null, // 当前编辑的用户
      userInfo: null, // 当前登录用户信息
    };
  },
  created() {
    const userInfoStr = localStorage.getItem("userInfo");
    // 将userInfo转换为对象
    this.userInfo = JSON.parse(userInfoStr);
    this.fetchOrgTree();
  },
  methods: {
    // 添加旗县
    handleAddDepartment() {
      this.$prompt("请输入旗县名称", "添加旗县", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{2,20}$/,
        inputErrorMessage: "旗县名称长度需在2-20个字符之间",
      })
        .then(async ({ value }) => {
          try {
            const parentId = this.currentNode?.id || null;
            await createDepartment({ name: value, parentId });
            this.$message.success("添加成功");
            this.fetchOrgTree();
          } catch (error) {
            console.error("添加旗县失败:", error);
          }
        })
        .catch(() => {});
    },

    // 编辑旗县名称
    handleEditDepartment(node, data) {
      this.$prompt("请输入新旗县名称", "修改旗县", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: data.name,
        inputPattern: /^.{2,20}$/,
        inputErrorMessage: "旗县名称长度需在2-20个字符之间",
      })
        .then(async ({ value }) => {
          try {
            await updateDepartment(data.id, { name: value });
            this.$message.success("修改成功");
            this.fetchOrgTree();
          } catch (error) {
            console.error("修改旗县失败:", error);
          }
        })
        .catch(() => {});
    },

    // 删除旗县
    handleDeleteDepartment(node, data) {
      this.$confirm(`确定删除旗县 "${data.name}" 吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            await deleteDepartment(data.id);
            this.$message.success("删除成功");
            this.fetchOrgTree();
          } catch (error) {
            console.error("删除旗县失败:", error);
          }
        })
        .catch(() => {});
    },

    // 获取组织架构树
    async fetchOrgTree() {
      try {
        const res = await getOrgTree();
        this.orgTree = res.data;
        // 默认选中第一个节点
        if (this.orgTree.length > 0) {
          this.currentNode = this.orgTree[0];
          this.filter.deptId = this.orgTree[0].id;
          this.fetchUserList();
          // 等待DOM更新后设置当前选中节点
          this.$nextTick(() => {
            this.$refs.tree?.setCurrentKey(this.orgTree[0].id);
          });
        }
      } catch (error) {
        console.error("获取组织架构失败:", error);
      }
    },
    // 获取用户列表
    async fetchUserList() {
      this.loading = true;
      try {
        console.log(this.filter);
        const params = {
          page: this.pagination.currentPage,
          size: this.pagination.pageSize,
          ...this.filter,
        };
        const res = await getUserList(params);
        if (res.data.rows && res.data.rows.length !== 0) {
          // 处理用户列表数据，确保department字段结构一致
          this.userList = res.data.rows.map((user) => ({
            ...user,
            department: user.department || { name: "" }, // 确保department对象存在
          }));
        } else {
          this.userList = [];
        }

        this.pagination.total = res.data.total;
      } catch (error) {
        console.error("获取用户列表失败:", error);
      } finally {
        this.loading = false;
      }
    },
    // 树节点点击事件
    handleNodeClick(data) {
      this.currentNode = data;
      this.filter.deptId = data.id;
      this.pagination.currentPage = 1;
      this.fetchUserList();
    },
    // 表格选择变化
    handleSelectionChange(val) {
      this.selectedUsers = val;
    },
    // 添加用户
    handleAddUser() {
      if (!this.currentNode) {
        this.$message.warning("请先选择组织架构");
        return;
      }
      this.currentUser = {
        department_id: this.currentNode?.id || "", // 确保传递当前旗县ID
      };
      this.dialogVisible = true;
    },
    // 编辑用户
    // 创建用户
    async handleCreateUser(userData) {
      try {
        await createUser(userData);
        // this.fetchUserList();
      } catch (error) {
        console.error("创建用户失败:", error);
        throw error;
      }
      // 如果创建用户成功，并且departmentid和当前选中的旗县不一致，则需要切换到departmentid的旗县
      if (userData.department_id !== this.currentNode?.id) {
        //遍历树，找到departmentid对应的节点
        this.orgTree.forEach((node) => {
          if (node.id === userData.department_id) {
            this.currentNode = node;
            this.filter.deptId = node.id;
            // 等待DOM更新后设置当前选中节点
            this.$nextTick(() => {
              this.$refs.tree?.setCurrentKey(node.id);
            });
          }
        });
      }
      this.fetchUserList();
      this.dialogVisible = false;
    },

    // 更新用户
    async handleUpdateUser(userData) {
      try {
        await updateUser(userData.id, userData);
        // this.fetchUserList();
      } catch (error) {
        console.error("更新用户失败:", error);
        throw error;
      }
      // 如果创建用户成功，并且departmentid和当前选中的旗县不一致，则需要切换到departmentid的旗县
      if (userData.department_id !== this.currentNode?.id) {
        //遍历树，找到departmentid对应的节点
        this.orgTree.forEach((node) => {
          if (node.id === userData.department_id) {
            this.currentNode = node;
            this.filter.deptId = node.id;
            // 等待DOM更新后设置当前选中节点
            this.$nextTick(() => {
              this.$refs.tree?.setCurrentKey(node.id);
            });
          }
        });
      }
      this.fetchUserList();
      this.dialogVisible = false;
    },

    handleEdit(row) {
      this.currentUser = {
        ...row,
      };
      this.dialogVisible = true;
    },
    async handleSendSMS(row) {
      try {
        await sendInitPwdBySMS({ user_id: row.id });
        this.$message.success("已发送短信");
      } catch (error) {
        console.error("通知失败:", error);
      }
    },
    // 删除用户
    handleDelete(row) {
      this.$confirm("确认删除该用户吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            await deleteUser(row.id);
            this.$message.success("删除成功");
            this.fetchUserList();
          } catch (error) {
            console.error("删除失败:", error);
          }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 批量删除
    handleBatchDelete() {
      this.$confirm(
        `确认删除选中的 ${this.selectedUsers.length} 个用户吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          try {
            const ids = this.selectedUsers.map((user) => user.id);
            await deleteUser(ids);
            this.$message.success("删除成功");
            this.selectedUsers = [];
            this.fetchUserList();
          } catch (error) {
            console.error("批量删除失败:", error);
          }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 筛选用户
    handleFilter() {
      this.pagination.currentPage = 1;
      this.fetchUserList();
    },
    // 分页变化
    handlePageChange(page) {
      this.pagination.currentPage = page;
      this.fetchUserList();
    },
  },
};
</script>

<style scoped>
.user-management-row {
  flex-wrap: nowrap;
  overflow-x: auto;
  min-width: 820px; /* 左侧320px + 右侧500px */
}
/* 覆盖Element UI Tree组件默认样式 */
:deep(.el-tree-node__content) {
  height: 40px; /* 设置节点内容高度 */
  line-height: 40px; /* 垂直居中 */
}

/* 加深选中节点的背景色 */
:deep(
    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content
  ) {
  background-color: #4a77ac; /* 使用更深的蓝色背景 */
  color: #ffffff; /* 文字颜色改为白色 */
  font-weight: 500; /* 加粗文字 */
}

/* 选中节点内的按钮文字颜色 */
:deep(
    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content
      .el-button.el-button--primary.is-link
  ) {
  color: #ffffff !important; /* 强制按钮文字为白色 */
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  height: 40px; /* 与节点高度保持一致 */
  line-height: 40px;
}
.user-management-container {
  padding: 20px;
}
.tree-card {
  height: calc(100vh - 120px);
  overflow-y: auto;
  min-width: 300px; /* 设置最小宽度防止变形 */
}

/* 移除卡片内容区域的padding */
:deep(.tree-card .el-card__body) {
  padding: 0;
  padding-top: 20px;
}
.table-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
